import {
    RxDocument,
    RxJsonSchema
} from 'rxdb';
import { Antenna } from '../models/antenna';

export type AntennaDoc = RxDocument<Antenna, {}>

export const antennaSchema: RxJsonSchema<Antenna> = {
    title: 'antenna schema',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        id: {
            type: 'string',
            primary: true
        },
        antenna_id: { type: ['string', 'null'] },
        importfileid: { type: ['number', 'null'] },
        stage: { type: ['string', 'null'] },
        building_id: { type: ['string', 'null'] },
        market_id: { type: ['string', 'null'] },
        floor_number: { type: ['number', 'null'] },
        floor_name: { type: ['string', 'null'] },
        latitude: { type: ['number', 'null'] },
        longitude: { type: ['number', 'null'] },
        height: { type: ['number', 'null'] },
        azimuth: { type: ['number', 'null'] },
        tilt: { type: ['number', 'null'] },
        antenna_owner: { type: ['string', 'null'] },
        range_meters: { type: ['number', 'null'] },
        azimuth_beam_width: { type: ['number', 'null'] },
        elevation_beam_width: { type: ['number', 'null'] },
        mount_type: { type: ['string', 'null'] },
        make: { type: ['string', 'null'] },
        model: { type: ['string', 'null'] },
        description: { type: ['string', 'null'] },
        updatedAt: { type: 'number' }
    }
};

export const antennaPullQueryBuilder = () => {
    return (doc) => {
        if (!doc) {
            doc = {
                id: '',
                antenna_id: '',
                importfileid: 0,
                stage: '',
                building_id: '',
                market_id: '',
                floor_number: 0,
                floor_name: '',
                latitude: 0,
                longitude: 0,
                height: 0,
                azimuth: 0,
                tilt: 0,
                antenna_owner: '',
                range_meters: 0,
                azimuth_beam_width: 0,
                elevation_beam_width: 0,
                make: '',
                model: '',
                updatedAt: 0,
                deleted: false,
                _rev: ''
            };
        }

        const query = `{
            feedForRxdbAntennas(lastId: "${doc.id}", minUpdatedAt: ${doc.updatedAt}){
                id
                antenna_id
                importfileid
                stage
                building_id
                market_id
                floor_number
                floor_name
                latitude
                longitude
                height
                azimuth
                tilt
                antenna_owner
                range_meters
                azimuth_beam_width
                elevation_beam_width
                mount_type
                make
                model
                description
                updatedAt
                deleted
                _rev
            }
        }`;
        return {
            query,
            variables: {}
        };
    };
};

// Need to have shared schema with server for this to work
export const graphQLGenerationInput = {
    allAntennas: {
        schema: antennaSchema,
        feedKeys: [
            'id',
            'antenna_id',
            'updatedAt'
        ],
        deletedFlag: 'deleted'
    }
};